import React from "react";

import Editor from "./BridPrimaryHeaderEditor";
import EditorWrapper from '../../EditorWrapper';

import BridPrimaryHeaderBox from "../../../redesign/components/BridPrimaryHeaderBox";

const BSeeMoreLink = props => {

    const { settings } = props;

    return (
        <div className={props.classes + ' pos-relative'} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <BridPrimaryHeaderBox settings={settings} />
        </div>
    )
}

export default BSeeMoreLink;